/*
  Brand birds (round 19). sections/about-v2-luxe.liquid loads this file on the Our Story page.

  The house mark is two doves, each with an olive branch. It stands above the hero text of the page. When the
  doors of the intro open, it is made in front of the visitor:

  1. Eight gold doves are in the air as the light behind the doors dies away. They fly all over the hall,
     each on a path made up afresh, never leaving the window and keeping clear of the middle.
  2. One by one they turn for the middle of the hall. The first comes down as the left dove of the mark and
     the second as the right one, each melting in a small whirl of liquid gold (the landing of the side
     birds). Every dove after that falls into the mark, one at a time with a pause between them; the mark
     swells one step once each of them has gone into it, and then stands still until the next (round 20: it
     used to grow without a break; round 21: the swell waits for the dove to be gone). A little gold dust lifts around the mark at every landing, and a glint crosses
     the dove that took it.
  3. When the eighth is in, one band of light crosses the whole mark from left to right. The mark then rises
     to its place above the text, settling to its resting size, and the text comes in beneath it.

  A scroll, a tap or a key at any moment ends the show at once: the mark goes to its place and the text
  appears. Visitors who ask for reduced motion, and visitors for whom the intro does not play, simply find
  the mark above the text.

  The page calls VRBrandBirds.play(ms until the doors begin to open) or VRBrandBirds.still().

  ART is written by the build script from the traced logo: the pieces of the left dove (the right one is its
  mirror), in the logo's own pixels, each with the group it belongs to and its middle.
*/
(function () {
  'use strict';
  var slot = document.querySelector('[data-vr-brand-mark]');
  if (!slot || slot.getAttribute('data-ready')) return;
  slot.setAttribute('data-ready', '1');
  var hero = slot.closest ? slot.closest('.vr-hero-section') : null;
  if (!hero) hero = slot.parentNode;

  var ART = {"w":98,"h":107,"pieces":[{"d":"M52.2 0C53 -0.6 54.3 -0.1 54.8 0C55.3 0.1 54.7 0.3 55 0.6C55.3 0.9 56.3 1.6 56.7 2.1C57.1 2.5 57.4 2.7 57.7 3.4C58 4.1 58.5 4.9 58.6 6C58.8 7.1 58.5 9.1 58.5 10.2C58.6 11.3 58.9 11.9 59.1 12.6C59.3 13.3 59.7 13.8 59.8 14.3C59.9 14.9 60 15 59.8 15.9C59.6 16.8 59.4 17.9 58.7 19.8C58 21.8 56.2 26 55.8 27.6C55.4 29.2 55.7 28.3 56.2 29.6C56.6 30.9 57.9 34.5 58.4 35.6C58.9 36.6 58.8 35.7 59 35.7C59.2 35.7 59.3 35.8 59.4 35.4C59.5 35 59.4 34.1 59.5 33.5C59.6 32.9 59.6 32.5 60 31.6C60.4 30.7 61.6 29.1 61.9 28.3C62.2 27.5 62 27.4 61.9 26.8C61.8 26.2 61.3 25.4 61.2 24.7C61 24 61 23.4 61 22.6C61 21.9 61 21.2 61.2 20.2C61.4 19.2 61.8 17.5 62.1 16.4C62.4 15.3 62.8 14.4 63.3 13.5C63.8 12.6 64.6 11.5 65.1 11C65.6 10.6 66 10.6 66.4 10.7C66.9 10.8 67.4 11.1 67.8 11.5C68.2 11.9 68.4 12.3 68.7 13C69.1 13.7 69.4 14.4 69.7 15.4C70 16.5 70.4 18.1 70.6 19.1C70.8 20.1 70.8 20.6 70.8 21.4C70.8 22.2 70.8 22.8 70.7 23.7C70.5 24.6 70.1 26.1 69.8 27C69.5 27.9 69.4 28.1 68.7 29C68.1 29.9 66.9 31.6 65.7 32.7C64.5 33.7 62.6 34.6 61.7 35.3C60.8 36 60.5 36.5 60.4 37.1C60.2 37.7 60.5 38.2 60.9 38.8C61.3 39.4 62.2 40.2 62.7 40.8C63.2 41.5 63.4 41.8 63.7 42.7C64 43.6 64.3 45.1 64.5 46.3C64.6 47.5 64.6 48.7 64.5 49.8C64.4 51 64 52.4 63.8 53.2C63.6 54 63.3 54.3 63.2 54.7C63.1 55.1 63.2 55.4 63.3 55.5C63.3 55.6 63.4 55.7 63.6 55.5C63.9 55.3 64.2 55 64.7 54.2C65.2 53.4 66.3 52.1 66.7 50.5C67.1 48.9 66.9 46 67.2 44.6C67.4 43.2 67.8 42.6 68.1 41.8C68.4 41.1 68.6 40.8 69.1 40.2C69.6 39.6 69.8 39.1 71 38.1C72.2 37.1 74.5 35.3 76.1 34.1C77.8 33 79.5 32 80.9 31.2C82.3 30.3 83.6 29.6 84.7 29.2C85.8 28.8 86.8 28.7 87.4 28.7C88 28.8 88.2 29 88.4 29.2C88.6 29.4 88.8 29.5 88.8 30C88.9 30.5 88.9 31.3 88.7 32.1C88.6 33 88 34.3 87.7 35.1C87.3 35.9 87.5 35.6 86.6 36.7C85.7 37.8 83.4 40.1 82.2 41.7C81 43.3 80.2 45.3 79.5 46.3C78.7 47.3 78.3 47.5 77.7 47.9C77.1 48.3 77 48.3 76.1 48.7C75.2 49.1 73.3 49.6 72.1 50.2C70.9 50.8 71.1 50.3 68.9 52.1C66.7 54 61.5 58.6 58.7 61.2C56 63.8 54 65.3 52.3 67.6C50.6 70 49 73.9 48.4 75.3C47.7 76.7 48.3 75.7 48.4 75.9C48.5 76.1 48.5 76.2 48.9 76.2C49.3 76.2 49.8 76.3 50.8 75.9C51.9 75.4 53.8 74.5 55.2 73.7C56.6 72.9 58.1 71.8 59.1 71.2C60.1 70.6 60.2 70.5 61.4 70.2C62.7 69.9 64.5 69.5 66.5 69.2C68.5 69 72.1 68.9 73.7 68.6C75.3 68.4 75.2 68.2 76 67.8C76.8 67.4 77.8 66.6 78.6 66.1C79.4 65.7 79.8 65.3 80.9 65.1C82 64.9 84.3 64.9 85.3 64.9C86.3 64.9 86.4 65 86.8 65.1C87.2 65.3 87.4 65.4 87.6 65.6C87.8 65.8 87.9 66.1 87.9 66.3C87.9 66.5 88.2 66.3 87.7 67C87.3 67.7 85.9 69.3 85.2 70.3C84.5 71.2 84.2 72.1 83.6 72.8C83.1 73.5 82.9 73.9 81.9 74.6C80.9 75.4 78.9 76.3 77.5 77.3C76.1 78.3 74.4 80.1 73.4 80.8C72.4 81.5 72.5 81.5 71.6 81.8C70.7 82.1 69.4 82.5 68.3 82.7C67.2 82.8 66.2 82.9 65.1 82.9C64 82.8 62.8 82.7 61.7 82.5C60.6 82.3 60 82.3 58.6 81.7C57.2 81.2 54.8 79.7 53.4 79.1C52 78.5 51 78.4 50.1 78.3C49.2 78.1 48.9 78.1 48.1 78.2C47.3 78.4 46 79 45.5 79.1C45 79.3 44.6 80.6 45.2 79C45.8 77.4 48.3 71.2 49.2 69.3C50 67.4 49.7 68.2 50.2 67.5C50.7 66.8 51 66.3 52.3 65.2C53.5 64.1 56.4 61.8 57.7 60.7C58.9 59.6 59 59.5 59.7 58.6C60.4 57.7 61.3 56.7 61.8 55.4C62.3 54.1 62.7 52.4 62.8 50.9C63 49.4 63 47.9 62.8 46.5C62.6 45.1 62.3 43.8 61.8 42.4C61.3 41 60.5 39.4 59.8 38.3C59.1 37.3 58.6 36.8 57.8 36.1C57.1 35.4 55.7 34.7 55.3 34.4C54.9 34.1 55.2 34.2 55.3 34.1C55.4 34 55.8 33.8 56 33.6C56.2 33.4 56.5 34.3 56.2 33.1C55.9 31.9 54.7 28.1 54.3 26.2C53.9 24.3 54.1 23 53.8 21.9C53.5 20.8 53.3 20.4 52.7 19.3C52.1 18.2 50.7 16.5 50.2 15.3C49.6 14.1 49.5 13.3 49.3 12.3C49.1 11.3 49.1 10.4 49.1 9.5C49.1 8.6 49.2 7.7 49.4 6.7C49.6 5.7 49.7 4.6 50.2 3.5C50.7 2.4 51.4 0.6 52.2 0Z","g":"branch","cx":66.8,"cy":45.5},{"d":"M29.5 1C29.8 1 30 0.7 31 1.2C31.9 1.7 33.4 2.9 35.2 4.2C36.9 5.6 39.7 7.9 41.3 9.3C42.9 10.7 43.9 11.7 44.8 12.7C45.7 13.7 46.1 14.4 46.7 15.5C47.4 16.6 47.8 17.1 48.7 19.6C49.6 22 51.5 28.1 52.2 30.1C53 32.1 52.8 31.2 53.2 31.7C53.6 32.2 54.5 32.9 54.7 33.3C55 33.7 54.9 33.8 54.8 33.8C54.7 33.9 54.7 34.1 53.9 33.8C53.1 33.5 51.6 32.6 49.9 32.1C48.3 31.6 45.3 31.1 44 30.7C42.7 30.4 42.6 30.2 42 29.8C41.4 29.4 41.1 29.2 40.4 28.5C39.7 27.7 38.8 26.1 37.7 25.1C36.6 24.2 34.7 23.3 33.8 22.7C32.9 22 32.8 22 32.3 21.3C31.9 20.5 31.4 19.9 31.1 18.2C30.8 16.4 31 13.5 30.7 10.8C30.4 8.1 29.3 3.7 29.1 2.1C28.8 0.5 29.1 1.6 29.1 1.4C29.2 1.2 29.2 1 29.5 1Z","g":"branch","cx":40.2,"cy":18},{"d":"M25.4 70.9C25.7 70.4 25.7 70.9 25.8 71C25.9 71.1 25.9 70.9 26 71.6C26 72.4 25.9 74.3 26.1 75.5C26.2 76.7 26.7 77.9 26.9 79C27 80.1 27.2 80.8 26.9 82.1C26.5 83.4 25.3 85.4 24.7 86.5C24.1 87.7 23.5 88.5 23.1 88.9C22.7 89.3 22.7 89.1 22.5 89.1C22.3 89.1 22 88.9 21.9 88.7C21.7 88.5 21.6 88.9 21.6 87.9C21.6 86.9 21.7 84.9 22.1 82.7C22.5 80.4 23.6 76.2 24.1 74.2C24.7 72.2 25.1 71.4 25.4 70.9Z","g":"tail","cx":24.4,"cy":80.9},{"d":"M44.5 79.8C45 79.6 44.7 80 44.6 80.3C44.4 80.6 44.1 81.2 43.7 81.6C43.3 82 42.9 82.4 42.2 82.8C41.6 83.2 41.3 83.4 40 83.8C38.8 84.2 35.8 84.7 34.7 85.1C33.6 85.5 33.6 85.8 33.3 86.1C33 86.4 33 86.1 33.1 86.7C33.2 87.3 33.7 88.9 33.8 89.6C33.8 90.3 33.6 90.8 33.4 91.1C33.2 91.3 32.8 91.2 32.3 90.9C31.8 90.6 31 89.3 30.5 89.1C30.1 88.8 29.7 88.9 29.6 89.2C29.5 89.4 29.6 89.8 30.1 90.5C30.6 91.2 32.1 92.8 32.5 93.4C33 94 32.8 93.6 32.9 94.2C33 94.8 33.2 96.1 33.2 96.8C33.2 97.5 33.1 98.1 33 98.5C32.9 98.9 32.8 99.1 32.6 99.2C32.4 99.3 32.2 99.3 32 99.1C31.8 99 31.7 99 31.2 98.4C30.7 97.8 29.8 96.6 29.1 95.5C28.5 94.4 27.6 92.6 27.2 92C26.8 91.4 26.8 91.7 26.6 91.7C26.4 91.7 26.3 91.7 26.2 91.9C26.1 92.2 25.5 91.5 26.2 93.1C26.9 94.7 29.7 99.8 30.5 101.3C31.2 102.8 30.6 101.9 30.4 102.3C30.3 102.7 30.1 103.4 29.7 103.8C29.3 104.1 28.8 104.4 28.3 104.3C27.9 104.3 27.4 104 27 103.6C26.6 103.3 26.6 103.5 26.1 102.3C25.6 101 24.4 97.4 24 96.3C23.5 95.2 23.7 95.6 23.4 95.8C23.1 96 22.6 96.7 22.3 97.4C21.9 98.1 21.6 98.5 21.2 99.7C20.8 101 20.2 103.7 19.7 104.9C19.1 106.1 18.3 106.6 17.8 106.9C17.4 107.2 17.1 107.1 16.9 106.9C16.7 106.7 16.7 106 16.8 105.6C16.8 105.2 16.5 105.8 17.1 104.5C17.7 103.2 19.2 99.8 20.2 98C21.2 96.2 22.4 94.4 22.8 93.5C23.3 92.6 23 93 22.9 92.5C22.9 92 22.7 91 22.7 90.6C22.7 90.2 22.6 90.3 22.9 90C23.1 89.7 23.8 89.1 24.1 89C24.4 88.8 24.4 88.9 24.6 89.1C24.8 89.2 25.1 89.7 25.3 89.8C25.5 89.9 25.7 89.9 25.8 89.7C25.9 89.6 26.1 89.4 26.2 88.9C26.3 88.4 26.2 87.4 26.3 87C26.4 86.6 26.6 86.5 26.8 86.3C27 86.2 27.3 86.1 27.5 86.2C27.8 86.4 28.1 87 28.3 87.1C28.5 87.2 28.6 87 28.7 86.9C28.8 86.8 28.9 86.6 28.8 86.3C28.7 86 28.3 85.5 28.1 85C28 84.5 27.8 83.7 27.8 83.1C27.8 82.5 27.9 81.6 28.1 81.3C28.3 81 28.3 80.6 28.8 81.2C29.3 81.7 30.7 83.9 31.3 84.5C32 85.2 32.2 85 32.7 85C33.2 85.1 33.7 84.9 34.1 84.7C34.5 84.6 34.7 84.2 35.1 84.1C35.5 83.9 35.7 84.1 36.7 83.7C37.8 83.3 40.1 82.4 41.4 81.7C42.7 81.1 43.9 80 44.5 79.8Z","g":"tail","cx":28.1,"cy":93.4},{"d":"M45 41.4C45.7 41.3 46.4 41.4 47 41.5C47.6 41.7 48.2 41.9 48.6 42.1C49 42.3 49.3 42.5 49.7 42.9C50 43.3 50.5 43.7 50.8 44.3C51.1 44.9 51.3 45.8 51.4 46.7C51.5 47.6 51.6 48.1 51.5 49.9C51.4 51.7 51.1 55.6 50.8 57.6C50.5 59.6 50.1 60.7 49.8 61.8C49.4 62.9 49.5 63.1 48.8 64.4C48.1 65.7 46.6 68.1 45.6 69.5C44.6 70.9 43.6 71.8 42.7 72.7C41.8 73.5 41.3 73.9 40.5 74.6C39.6 75.3 38.5 76 37.4 76.7C36.3 77.4 34.8 78.2 33.7 78.7C32.6 79.3 31.8 79.7 31 79.9C30.2 80.1 29.5 80.1 29.1 80.1C28.7 80 28.6 79.8 28.4 79.6C28.2 79.4 28.1 79.2 28 78.7C27.8 78.2 27.5 77.3 27.4 76.6C27.3 75.9 27.2 75.9 27.3 74.4C27.5 72.9 27.9 69.3 28.2 67.5C28.5 65.7 28.8 64.8 29.2 63.7C29.5 62.7 29.6 62.2 30.1 61.2C30.6 60.2 30.8 59.7 32.3 57.6C33.7 55.5 37.2 50.8 38.7 48.6C40.2 46.4 40.5 45.3 41.3 44.2C42 43.1 42.5 42.7 43.1 42.2C43.7 41.7 44.4 41.5 45 41.4Z","g":"body","cx":39.9,"cy":61},{"d":"M53.4 46C53.6 45.9 53.7 45.9 54 46.1C54.3 46.3 54.9 46.8 55.4 47.2C55.9 47.6 56.7 48.2 56.8 48.6C56.9 49 56.6 49.2 56.1 49.6C55.6 49.9 54.2 50.6 53.7 50.7C53.2 50.9 53.3 50.7 53.2 50.5C53.1 50.4 53 50.4 53 49.8C53 49.2 52.9 47.4 53 46.8C53.1 46.2 53.3 46.1 53.4 46Z","g":"beak","cx":54.5,"cy":48.4},{"d":"M25.4 32.2C25.7 31.8 25.7 32.1 25.9 32.2C26.1 32.3 25.8 31.7 26.5 32.6C27.2 33.5 29.3 36.4 30.3 37.6C31.2 38.8 31.1 38.6 32.3 39.7C33.5 40.8 36.6 43.4 37.6 44.3C38.6 45.3 38.1 45 38.2 45.4C38.2 45.8 39.4 43.8 37.8 46.4C36.2 49.1 30.4 58.7 28.8 61.3C27.1 63.9 28.2 61.8 27.9 61.8C27.6 61.9 27.5 61.9 27.2 61.7C26.9 61.5 26.8 61.5 26.1 60.7C25.4 59.9 23.8 57.7 23.1 56.7C22.5 55.7 22.4 55.6 22.1 54.5C21.8 53.4 21.4 51.5 21.2 50C21.1 48.5 21.1 47 21.3 45.6C21.4 44.2 21.6 43.4 22.1 41.6C22.6 39.8 23.6 36.3 24.1 34.7C24.7 33.1 25.1 32.6 25.4 32.2Z","g":"wing","cx":28.2,"cy":47.3},{"d":"M13.4 13.3C13.9 13.1 14.1 13.3 14.5 13.5C14.9 13.7 15 13.5 15.6 14.7C16.2 15.9 16.7 18.1 18.2 20.5C19.7 23 23.3 27.9 24.3 29.5C25.3 31.1 24.5 29.9 24.4 30.3C24.3 30.7 24.2 30.8 23.8 31.8C23.4 32.7 22.2 35.2 21.8 36C21.3 36.8 21.6 36.4 21.3 36.4C21 36.4 21.1 37 20.1 36C19.1 35.1 16.9 32.6 15.2 30.7C13.6 28.8 11.4 26.1 10.2 24.6C9 23.1 8.4 22.5 8.1 21.6C7.8 20.8 7.9 20.2 8.1 19.5C8.3 18.8 8.6 18.1 9.2 17.2C9.7 16.4 10.9 15.1 11.6 14.4C12.3 13.8 12.9 13.5 13.4 13.3Z","g":"wing","cx":16.1,"cy":24.6},{"d":"M5.9 24.3C6.1 24.2 6.3 24.1 6.6 24.3C6.9 24.4 5.4 23 7.6 25.2C9.8 27.4 17.7 35.1 19.8 37.4C21.9 39.6 20.4 37.9 20.4 38.7C20.4 39.5 20 41.6 19.8 42.4C19.6 43.1 19.6 43 19.4 43.1C19.2 43.3 19.1 43.3 18.7 43.2C18.3 43.2 18.2 43.2 17.2 42.8C16.2 42.4 14.3 41.6 12.7 40.7C11.1 39.8 8.7 38.6 7.3 37.7C5.9 36.8 5 36.1 4.3 35.3C3.6 34.4 3.5 33.5 3.3 32.6C3.1 31.7 3.1 31 3.3 30C3.4 29 3.9 27.4 4.2 26.5C4.5 25.7 4.9 25.3 5.1 24.9C5.4 24.5 5.7 24.4 5.9 24.3Z","g":"wing","cx":11.1,"cy":34.3},{"d":"M1.9 37.8C2.3 37.8 1.7 37.3 3.6 38.1C5.5 38.9 10.4 41.5 13 42.7C15.6 43.9 18 44.7 19 45.2C20.1 45.7 19.3 45.5 19.4 45.8C19.5 46.1 19.5 46.1 19.5 46.8C19.6 47.5 19.6 49.5 19.5 50.2C19.5 50.9 19.4 50.9 19.2 51.2C19 51.4 19.8 51.7 18.4 51.5C17 51.2 13.2 50.4 10.7 49.8C8.3 49.1 5.1 48.3 3.7 47.8C2.3 47.3 2.7 47.4 2.3 47C1.9 46.6 1.5 46.2 1.2 45.5C0.9 44.9 0.7 43.6 0.5 43.1C0.3 42.5 0.1 42.8 0 42.4C-0.1 41.9 -0.2 41 0 40.3C0.2 39.6 0.8 38.7 1.1 38.2C1.4 37.8 1.4 37.8 1.9 37.8Z","g":"wing","cx":9.4,"cy":45.1},{"d":"M2.4 49.8C2.9 49.8 3.3 49.8 4.8 50.1C6.3 50.5 9.6 51.5 11.4 51.9C13.2 52.3 14.4 52.4 15.7 52.5C17 52.6 18.6 52.5 19.3 52.6C20 52.7 19.7 52.8 19.9 53.2C20.1 53.5 20.5 54.2 20.7 54.7C20.9 55.3 21.1 55.9 21.2 56.3C21.3 56.7 21.2 56.9 21.1 57.1C21 57.4 21.3 57.5 20.4 57.8C19.5 58 17.7 58.4 15.6 58.8C13.5 59.1 9.9 59.6 8 59.8C6.1 60 5.1 60 4.3 59.8C3.5 59.7 3.5 59.4 3.1 58.7C2.7 58 2.3 57.1 2 55.9C1.7 54.7 1.6 52.3 1.5 51.4C1.5 50.5 1.6 50.7 1.8 50.4C1.9 50.1 1.9 49.8 2.4 49.8Z","g":"wing","cx":10.3,"cy":55.2},{"d":"M22 58.4C22.9 58.3 23.1 58.8 23.6 59.2C24.1 59.6 24.5 60.3 24.8 60.7C25 61.1 25 61.3 25 61.6C24.9 61.9 25.5 62 24.5 62.7C23.5 63.4 21 64.7 19 65.7C17 66.7 14 68.2 12.7 68.8C11.4 69.3 11.6 69.1 11.1 69C10.6 69 10.2 68.9 9.7 68.6C9.2 68.3 8.8 68.1 8.2 67.4C7.6 66.7 6.5 65.2 6.1 64.4C5.7 63.6 5.8 62.9 5.8 62.5C5.8 62.1 5.9 61.9 6.1 61.7C6.2 61.5 5 61.4 6.5 61.3C8 61.1 12.9 61 14.9 60.8C16.9 60.5 17.2 60.2 18.4 59.8C19.6 59.4 21.2 58.5 22 58.4Z","g":"wing","cx":14.9,"cy":63.6},{"d":"M25.2 62.9C26.2 62.3 26.5 63.1 26.9 63.3C27.3 63.5 27.6 63.9 27.7 64.2C27.9 64.5 28.3 64.1 27.8 65C27.3 65.9 25.7 68.2 24.6 69.5C23.5 70.8 22.2 71.9 21.4 72.7C20.6 73.4 20.2 73.6 19.6 73.8C19 74 18.5 74.1 17.7 73.9C16.9 73.8 15.6 73.2 15 72.8C14.3 72.4 14 72 13.7 71.7C13.5 71.4 13.5 71.2 13.5 71C13.6 70.8 13.3 70.7 13.9 70.3C14.6 69.9 16.2 69.3 17.3 68.7C18.4 68.1 19.3 67.7 20.6 66.7C21.9 65.8 24.1 63.5 25.2 62.9Z","g":"wing","cx":21,"cy":69}]};
  /*consts*/
  var W = ART.w, H = ART.h;
  var CENTRE = [39.9, 61];            /* middle of the body: the point that follows the flight path */
  var PIVOT = [33, 50];               /* the shoulder: the fan of feathers opens from here */
  var HEART = [46, 57];               /* middle of a dove with its branch: the whirl turns about it */
  var AXIS = 64.7 * Math.PI / 180;    /* how far the body leans back from level in the mark */
  var DEG = 180 / Math.PI;
  var GOLD = [[0, '#96700f'], [0.4, '#cfa436'], [0.78, '#f2d578'], [1, '#d8b244']];
  var GOLD_FAR = [[0, '#6f4f0c'], [1, '#a98322']];
  var GOLD_LIT = [[0, '#dcbb5e'], [0.5, '#f8e7ab'], [1, '#ecd384']]; /* a dove being taken up by the mark */
  var DUST = ['#f2d578', '#f2d578', '#e2bd55', '#fff4d2', '#cfa436'];
  /*end consts*/
  var NS = 'http://www.w3.org/2000/svg';

  /*timing*/
  var COUNT = 8;                      /* doves */
  var STAGE = 1.5;                    /* the finished mark in the middle of the hall, against its resting size (set for the window in measure) */
  var FIRST = 0.52;                   /* the mark when the first dove lands, against the finished one */
  var ENTER = 0.45, ENTER_SPREAD = 0.9; /* the doves come in behind the opening doors: seconds after they begin to open */
  var FIRST_DOWN = 4.7;               /* the first dove touches down */
  var GAP = 1.15;                     /* and the others follow one at a time, this far apart */
  var BRAKE = 1.15;                   /* a dove slows over its last seconds */
  var MELT = 1.2;                     /* the whirl that makes a dove of the mark */
  var ABSORB = 0.6;                   /* a dove taken up by the mark */
  var GROW_AFTER = 0.62, GROW = 0.42; /* the mark swells one step once the dove is gone into it, and is still again before the next */
  var GLINT = 0.5;                    /* the glint on the dove that took a landing */
  var GLEAM = 0.95;                   /* the band of light over the finished mark */
  var RISE = 1.3;                     /* the way up to its place */
  var CRUISE = 400;                   /* pixels a second on a 1920 window */
  function down(n) { return FIRST_DOWN + (n - 1) * GAP; }
  var SHINE_AT = down(COUNT) + GROW_AFTER + GROW + 0.15;   /* the band of light waits for the last swell */
  var RISE_AT = SHINE_AT + 0.45;
  var TEXT_AT = RISE_AT + RISE * 0.78;
  var END_AT = RISE_AT + RISE + 0.15;
  /*end timing*/

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var logo = null;                    /* the mark itself: the element that travels from the stage to its place */
  var doves = [];                     /* { el, art, pose, bird, parts, face, formed } */
  var state = '';                     /* '', waiting, flying, done, still */
  var serial = 0;
  var timers = [];

  function el(tag, cls) { var n = document.createElement(tag); if (cls) n.className = cls; return n; }
  function svg(tag, attrs) { var n = document.createElementNS(NS, tag); for (var k in attrs) n.setAttribute(k, attrs[k]); return n; }

  /* ---- the still mark ---- */
  function build() {
    logo = el('div', 'vr-mark');
    var defs = svg('svg', { width: '0', height: '0', 'class': 'vr-mark__defs', focusable: 'false' });
    var grad = svg('linearGradient', { id: 'vr-mark-gold', gradientUnits: 'userSpaceOnUse', x1: '0', y1: '38', x2: String(W), y2: '66' });
    for (var i = 0; i < GOLD.length; i++) grad.appendChild(svg('stop', { offset: String(GOLD[i][0]), 'stop-color': GOLD[i][1] }));
    defs.appendChild(grad);
    var lit = svg('linearGradient', { id: 'vr-mark-lit', gradientUnits: 'userSpaceOnUse', x1: '0', y1: '38', x2: String(W), y2: '66' });
    for (i = 0; i < GOLD_LIT.length; i++) lit.appendChild(svg('stop', { offset: String(GOLD_LIT[i][0]), 'stop-color': GOLD_LIT[i][1] }));
    defs.appendChild(lit);
    logo.appendChild(defs);
    var far = 1;
    for (i = 0; i < ART.pieces.length; i++) far = Math.max(far, Math.sqrt(Math.pow(ART.pieces[i].cx - HEART[0], 2) + Math.pow(ART.pieces[i].cy - HEART[1], 2)));
    for (var d = 0; d < 2; d++) {
      var dove = el('span', 'vr-mark__dove' + (d ? ' vr-mark__dove--mirror' : ''));
      var art = svg('svg', { viewBox: '0 0 ' + W + ' ' + H, 'class': 'vr-mark__art', focusable: 'false' });
      var pose = svg('g', {}), branch = svg('g', {}), bird = svg('g', {});
      pose.appendChild(branch); pose.appendChild(bird);
      var parts = [];
      for (i = 0; i < ART.pieces.length; i++) {
        var piece = ART.pieces[i];
        var p = svg('path', { d: piece.d, fill: 'url(#vr-mark-gold)', 'fill-rule': 'evenodd' });
        (piece.g === 'branch' ? branch : bird).appendChild(p);
        parts.push({ el: p, g: piece.g, w: Math.sqrt(Math.pow(piece.cx - HEART[0], 2) + Math.pow(piece.cy - HEART[1], 2)) / far });
      }
      art.appendChild(pose);
      dove.appendChild(art);
      logo.appendChild(dove);
      doves.push({ el: dove, art: art, pose: pose, bird: bird, parts: parts, face: d ? -1 : 1, formed: false });
    }
    slot.appendChild(logo);
  }
  /* the page hears when the mark is in its place (the gold leaf of the page begins then) */
  var told = false;
  function tell() {
    if (told) return;
    told = true;
    try { document.dispatchEvent(new CustomEvent('vr:brand-mark-ready')); } catch (e) {}
  }
  function perch(dv, still) { dv.formed = true; dv.el.classList.add('is-perched'); if (still) dv.el.classList.add('is-still'); }
  function still() {
    if (state) return;
    state = 'still';
    for (var i = 0; i < doves.length; i++) perch(doves[i], true);
    tell();
  }

  /*maths*/
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function smooth(x) { x = x < 0 ? 0 : x > 1 ? 1 : x; return x * x * (3 - 2 * x); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  /*end maths*/

  /*stage*/
  /* the stage is a little larger against the resting mark on wide windows than on phones */
  function stageFor(vw) { return Math.max(1.3, Math.min(1.5, 0.88 + vw / 2200)); }
  /* How large the mark is in the middle of the hall at each moment, against its resting size. The first two
     doves make it, at the size of a dove in flight. Each dove after that makes it one equal step larger: the
     step is quick, begins as the dove is taken up and is over long before the next dove comes, so the mark
     is seen to stand still between them. */
  function stageScale(t) {
    var steps = 0;
    for (var n = 3; n <= COUNT; n++) steps += smooth((t - (down(n) + GROW_AFTER)) / GROW);
    return STAGE * FIRST * Math.pow(1 / FIRST, steps / (COUNT - 2));
  }
  /* where the middle of a dove's body is on the stage, and how large the drawing is there */
  function stagePlace(v, side, scale) {
    var d = v.d * scale;
    return { x: v.cx + (side ? 1 : -1) * (1.09 - CENTRE[0] / W) * d, y: v.cy + (CENTRE[1] / W - H / W / 2) * d, k: d / W };
  }
  /*end stage*/

  /*route*/
  /* A path for one dove, drawn backwards from its place: up and away from the mark, a wander through the
     hall, and out over the left or the right edge (flown the other way round, that is the dove coming in,
     wandering and coming down on its place from above and from the outside). The path is steered, not
     joined from points: its bend changes little by little and is never tighter than a circle of radius
     o.R, so no dove turns on the spot. The walls of the hall and the middle, where the mark stands, push
     it away the more strongly the nearer its course brings it to them; otherwise it makes for one chance
     spot after another with a sway of its own.
     o.A: its place. o.from: -1 if the last leg comes from the left, 1 from the right. o.L: how long the path
     should be for the dove to be in the air at about the wanted moment. o.edge: 0 in over the left edge,
     1 over the right. A path that touches the edge of the hall is thrown away and thrown again.
     Returns the curve as samples with the distance travelled at each. */
  function wrap(a) { while (a > Math.PI) a -= 2 * Math.PI; while (a < -Math.PI) a += 2 * Math.PI; return a; }
  function route(o) {
    var hall = o.hall, zone = o.zone, R = o.R, ds = Math.max(3, R / 18), kmax = 1 / R;
    var inner = { x0: hall.x0 + o.keep, x1: hall.x1 - o.keep, y0: hall.y0 + o.keep, y1: hall.y1 - o.keep };
    var look = 1.45 * R + o.keep * 0.5, band = look * 0.55;
    var hx = (inner.x0 + inner.x1) / 2, hy = (inner.y0 + inner.y1) / 2;
    var inZone = function (px, py) { var a = (px - zone.x) / (zone.rx + o.keep), b = (py - zone.y) / (zone.ry + o.keep); return a * a + b * b; };
    var best = null, bestScore = 1e9;
    for (var go = 0; go < 90; go++) {
      var slope = rnd(0.5, 1.0);
      var th = Math.atan2(-Math.sin(slope), o.from * Math.cos(slope));
      var x = o.A.x, y = o.A.y, kap = 0, len = 0, fine = true, clear = !zone, phase = 0, crossed = 0, why = '';
      var pts = [{ x: x, y: y }];
      var f1 = rnd(0.5, 1.1) / R, f2 = rnd(1.3, 2.4) / R, a1 = rnd(0, 6.28), a2 = rnd(0, 6.28);
      var aim = null, aimLeft = 0, E = null, bias = 0;
      var ex = o.edge ? o.vw + o.out : -o.out;
      var guard = Math.ceil((o.L * 1.7 + 3000) / ds);
      while (guard-- > 0) {
        var cs = Math.cos(th), sn = Math.sin(th);
        if (phase === 0 && clear) {
          /* time to go? the way to the edge, and the turn towards it, are counted in */
          var bear = Math.abs(wrap(Math.atan2(0, ex - x) - th));
          if (len + (Math.abs(ex - x) + R * bear * 0.9) * 1.04 >= o.L) {
            phase = 1;
            E = { x: ex, y: Math.max(inner.y0, Math.min(inner.y1, y + rnd(-0.25, 0.25) * Math.abs(ex - x))) };
          }
        }
        if (zone && !clear && inZone(x, y) > 1.15) clear = true;
        /* what pushes it: each wall and the middle, felt at two points ahead on its course. It turns
           towards the side the way out (nx, ny) lies on; head on, towards the open hall, and keeps to it */
        var push = 0, felt = 0;
        for (var pr = 0; pr < 2; pr++) {
          var far = pr ? look : look * 0.5, px = x + cs * far, py = y + sn * far, wgt = pr ? 1 : 1.5;
          for (var w = 0; w < 5; w++) {
            var c, nx, ny, force;
            if (w === 0) { c = py - inner.y0; nx = 0; ny = 1; }
            else if (w === 1) { c = inner.y1 - py; nx = 0; ny = -1; }
            else if (w === 2) { if (phase === 1 && !o.edge) continue; c = px - inner.x0; nx = 1; ny = 0; }
            else if (w === 3) { if (phase === 1 && o.edge) continue; c = inner.x1 - px; nx = -1; ny = 0; }
            else {
              if (!zone || !clear) continue;
              c = inZone(px, py); if (c >= 1.4) continue;
              nx = x - zone.x; ny = y - zone.y;
              force = wgt * 1.5 * Math.pow(Math.min(1.5, (1.4 - c) / 0.5), 2);
            }
            if (w < 4) { if (c >= band) continue; force = wgt * Math.pow(Math.min(2, 1 - c / band), 2); }
            var cr = cs * ny - sn * nx, nl = Math.sqrt(nx * nx + ny * ny) || 1, sign;
            if (Math.abs(cr) < 0.2 * nl) { if (!bias) bias = (cs * (hy - y) - sn * (hx - x)) >= 0 ? 1 : -1; sign = bias; } else sign = cr > 0 ? 1 : -1;
            push += sign * force; felt += force;
          }
        }
        if (felt < 0.02) bias = 0;
        var own;
        if (phase === 1) {
          own = wrap(Math.atan2(E.y - y, E.x - x) - th) / (look * 0.6);
        } else {
          if (!aim || aimLeft <= 0 || (aim.x - x) * (aim.x - x) + (aim.y - y) * (aim.y - y) < R * R) {
            for (var tr = 0; tr < 12; tr++) { aim = { x: rnd(inner.x0, inner.x1), y: rnd(inner.y0, inner.y1) }; if (!zone || inZone(aim.x, aim.y) > 1.5) break; }
            aimLeft = rnd(0.7, 1.3) * o.diag;
          }
          var pursuit = wrap(Math.atan2(aim.y - y, aim.x - x) - th) / (look * 1.1);
          var sway = kmax * (Math.sin(a1 + len * f1) * 0.6 + Math.sin(a2 + len * f2) * 0.4);
          own = (0.5 * Math.max(-kmax, Math.min(kmax, pursuit)) + 0.55 * sway) * (clear ? 1 : 0.25);
        }
        own = Math.max(-kmax, Math.min(kmax, own));
        var want = own * (1 - Math.min(1, felt)) + kmax * Math.max(-1, Math.min(1, push));
        want = Math.max(-kmax, Math.min(kmax, want));
        kap += (want - kap) * Math.min(1, ds / (R * 0.55));
        th += kap * ds; x += Math.cos(th) * ds; y += Math.sin(th) * ds; len += ds; aimLeft -= ds;
        pts.push({ x: x, y: y });
        if (zone && clear && inZone(x, y) < 0.72) crossed++;
        if (y < hall.y0 || y > hall.y1) { fine = false; why = 'y'; break; }
        if (phase === 0) { if (x < hall.x0 || x > hall.x1) { fine = false; why = 'x'; break; } }
        else { if (o.edge ? x < hall.x0 : x > hall.x1) { fine = false; why = 'far'; break; } if (o.edge ? x >= ex : x <= ex) break; }
      }
      if (guard <= 0 || phase === 0) { if (fine) why = guard <= 0 ? 'long' : 'in'; fine = false; }
      var score = Math.abs(len - o.L) / o.L + (fine ? 0 : 10) + (crossed ? 0.5 : 0);
      if (score < bestScore) {
        bestScore = score;
        var out2 = [], s = 0;
        for (var i = pts.length - 1; i >= 0; i--) {
          if (i < pts.length - 1) s += Math.sqrt(Math.pow(pts[i].x - pts[i + 1].x, 2) + Math.pow(pts[i].y - pts[i + 1].y, 2));
          out2.push({ x: pts[i].x, y: pts[i].y, s: s });
        }
        best = { pts: out2, len: s, fine: fine, crossed: crossed, off: (s - o.L) / o.L, why: why, tries: go + 1 };
      }
      if (bestScore < 0.04) break;
    }
    return best;
  }
  function along(path, s) {
    var a = path.pts, lo = 0, hi = a.length - 1;
    if (s <= 0) return { x: a[0].x, y: a[0].y };
    if (s >= path.len) return { x: a[hi].x, y: a[hi].y };
    while (hi - lo > 1) { var m = (lo + hi) >> 1; if (a[m].s <= s) lo = m; else hi = m; }
    var f = (s - a[lo].s) / ((a[hi].s - a[lo].s) || 1);
    return { x: lerp(a[lo].x, a[hi].x, f), y: lerp(a[lo].y, a[hi].y, f) };
  }
  /* full speed until `from` (a share of the flight time), then a long slowing: the share of the path covered */
  var SLOW_TO = 0.12;
  function wholeOf(from) { return 1 - (1 - SLOW_TO) * (1 - from) / 2; }
  function covered(u, from) {
    var whole = wholeOf(from);
    if (u <= from) return u / whole;
    var z = (u - from) / (1 - from);
    return (u - (1 - SLOW_TO) * (1 - from) * (z * z * z - z * z * z * z / 2)) / whole;
  }
  /*end route*/

  /*paint*/
  /* One dove on the canvas. st.x, st.y: the middle of its body in window coordinates. st.k: its size.
     st.face: 1 facing right, -1 facing left, in between while it turns. st.lean: how far it is tipped
     forward from the pose of the mark. st.near, st.far: the wings, 1 raised as in the mark, 0 edge on,
     below 0 on the down stroke; the far wing is a shade darker. */
  function paint(g, shapes, gold, far, st) {
    g.save();
    g.globalAlpha = st.alpha;
    g.translate(st.x, st.y);
    g.scale(st.face * st.k, st.k);
    g.rotate(st.lean);
    g.translate(-CENTRE[0], -CENTRE[1]);
    if (st.farAlpha > 0.01) {
      g.save();
      g.translate(PIVOT[0] + 2.5, PIVOT[1] - 1.5); g.rotate((1 - st.far) * 0.34); g.scale(st.far * 0.94, 0.94); g.translate(-PIVOT[0], -PIVOT[1]);
      g.fillStyle = far;
      g.globalAlpha = st.alpha * st.farAlpha;
      g.fill(shapes.wing, 'evenodd');
      g.restore();
    }
    g.fillStyle = gold;
    g.fill(shapes.tail, 'evenodd'); g.fill(shapes.body, 'evenodd'); g.fill(shapes.beak, 'evenodd');
    g.translate(PIVOT[0], PIVOT[1]); g.rotate((1 - st.near) * 0.36); g.scale(st.near, 1); g.translate(-PIVOT[0], -PIVOT[1]);
    g.fill(shapes.wing, 'evenodd');
    g.restore();
  }
  /*end paint*/

  /*pose*/
  /* The same pose written for the still drawing, in the mark's own units. p.x, p.y: the middle of the
     body. p.s: size against the mark's. p.f: 1 facing as the mark does, -1 the other way. p.lean as above. */
  function poseTransform(p) {
    return 'translate(' + p.x.toFixed(2) + ' ' + p.y.toFixed(2) + ') scale(' + (p.f * p.s).toFixed(4) + ' ' + p.s.toFixed(4) + ') rotate(' + (p.lean * DEG).toFixed(2) + ') translate(' + (-CENTRE[0]) + ' ' + (-CENTRE[1]) + ')';
  }
  function wingTransform(near) {
    return ' translate(' + PIVOT[0] + ' ' + PIVOT[1] + ') rotate(' + ((1 - near) * 0.36 * DEG).toFixed(2) + ') scale(' + near.toFixed(4) + ' 1) translate(' + (-PIVOT[0]) + ' ' + (-PIVOT[1]) + ')';
  }
  /*end pose*/

  /* ---- things that run for a while on the clock of the show: { at, dur, step(0..1), end() } ---- */
  var acts = [];
  function act(at, dur, step, end) { acts.push({ at: at, dur: dur, step: step, end: end, over: false }); }
  function runActs(t, all) {
    for (var i = 0; i < acts.length; i++) {
      var a = acts[i];
      if (a.over) continue;
      if (all) { a.over = true; if (a.end) a.end(); continue; }
      if (t < a.at) continue;
      var x = Math.min(1, (t - a.at) / (a.dur || 0.0001));
      if (x < 1) { if (a.step) a.step(x); } else { a.over = true; if (a.end) a.end(); }
    }
  }

  /* ---- the landing of the first two: the dove melts into a whirl of liquid gold, and the whirl opens as
     the mark's own dove (the landing of the side birds, on the clock of the show) ---- */
  function about(turn, size) {
    var heart = HEART[0] + ' ' + HEART[1];
    return 'rotate(' + turn.toFixed(2) + ' ' + heart + ') translate(' + heart + ') scale(' + size.toFixed(4) + ') translate(' + (-HEART[0]) + ' ' + (-HEART[1]) + ')';
  }
  function liquid(seed, small) {
    var id = 'vr-mark-melt-' + (++serial);
    var f = svg('filter', small ? { id: id, filterUnits: 'userSpaceOnUse', x: '-38', y: '-20', width: '158', height: '162', 'color-interpolation-filters': 'sRGB' }
      : { id: id, filterUnits: 'userSpaceOnUse', x: '-60', y: '-52', width: '212', height: '218', 'color-interpolation-filters': 'sRGB' });
    f.appendChild(svg('feTurbulence', { type: 'fractalNoise', baseFrequency: '0.045', numOctaves: '2', seed: String(seed), result: 'n' }));
    var warp = svg('feDisplacementMap', { 'in': 'SourceGraphic', in2: 'n', scale: '0', xChannelSelector: 'R', yChannelSelector: 'G', result: 'w' });
    var blur = svg('feGaussianBlur', { 'in': 'w', stdDeviation: '0', result: 'b' });
    var edge = svg('feColorMatrix', { 'in': 'b', type: 'matrix', values: '1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0' });
    f.appendChild(warp); f.appendChild(blur); f.appendChild(edge);
    return { el: f, id: id, blur: blur, warp: warp, edge: edge, set: function (swell, soft, bend) {
      var hard = 1 + 15 * Math.min(1, swell * 4);
      blur.setAttribute('stdDeviation', (soft * swell).toFixed(2));
      warp.setAttribute('scale', (bend * swell).toFixed(2));
      edge.setAttribute('values', '1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 ' + hard.toFixed(2) + ' ' + (-(hard - 1) * 0.36).toFixed(2));
    } };
  }
  /* a copy of the flying dove, drawn in the mark's own units in the pose it had in the air */
  function ghostOf(dv, last) {
    var box = dv.el.getBoundingClientRect();
    var k = box.width / W;
    var from = { x: dv.face > 0 ? (last.x - box.left) / k : (box.right - last.x) / k, y: (last.y - box.top) / k, s: last.k / k, f: last.face * dv.face, lean: last.lean };
    var ghost = { el: svg('g', {}), parts: [], pose: poseTransform(from), wing: wingTransform(last.near) };
    for (var i = 0; i < dv.parts.length; i++) {
      if (dv.parts[i].g === 'branch') continue;
      var copy = dv.parts[i].el.cloneNode(false);
      copy.removeAttribute('transform'); copy.removeAttribute('opacity');
      ghost.el.appendChild(copy);
      ghost.parts.push({ el: copy, g: dv.parts[i].g, w: dv.parts[i].w });
    }
    return ghost;
  }
  function morph(dv, last, at) {
    var ghost = ghostOf(dv, last);
    var f = liquid(Math.round(rnd(1, 90)));
    dv.art.insertBefore(f.el, dv.art.firstChild);
    dv.pose.appendChild(ghost.el);
    var step = function (t) {
      var a = smooth(t / 0.54), i;
      if (ghost.el) {
        if (t >= 0.6) { ghost.el.parentNode.removeChild(ghost.el); ghost.el = null; } else {
          for (i = 0; i < ghost.parts.length; i++) ghost.parts[i].el.setAttribute('transform', about(230 * a * a - 130 * a * ghost.parts[i].w, 1 - 0.7 * a) + ' ' + ghost.pose + (ghost.parts[i].g === 'wing' ? ghost.wing : ''));
          ghost.el.setAttribute('opacity', (1 - smooth((t - 0.36) / 0.22)).toFixed(3));
        }
      }
      var b = smooth((t - 0.3) / 0.7);
      var show = smooth((t - 0.3) / 0.2).toFixed(3);
      for (i = 0; i < dv.parts.length; i++) {
        dv.parts[i].el.setAttribute('transform', about(-(1 - b) * (140 + 210 * dv.parts[i].w), 0.3 + 0.7 * b));
        dv.parts[i].el.setAttribute('opacity', show);
      }
      f.set(Math.pow(Math.sin(Math.PI * Math.min(1, t * 1.06)), 1.2), 4.3, 9);
    };
    step(0);
    dv.pose.setAttribute('filter', 'url(#' + f.id + ')');
    dv.el.classList.add('is-forming');
    dv.formed = true;
    act(at, MELT, step, function () {
      dv.pose.removeAttribute('filter');
      if (f.el.parentNode) f.el.parentNode.removeChild(f.el);
      if (ghost.el && ghost.el.parentNode) ghost.el.parentNode.removeChild(ghost.el);
      for (var i = 0; i < dv.parts.length; i++) { dv.parts[i].el.removeAttribute('transform'); dv.parts[i].el.removeAttribute('opacity'); }
      perch(dv, false);
      dv.el.classList.remove('is-forming');
    });
  }
  /* ---- every later landing: the dove winds into the heart of the mark's dove and is taken up by it. Only
     the arriving dove runs liquid, in a lighter gold so that it shows against the mark; the mark itself
     stays crisp ---- */
  function absorb(dv, last, at) {
    var ghost = ghostOf(dv, last);
    var f = liquid(Math.round(rnd(1, 90)), true);
    for (var i = 0; i < ghost.parts.length; i++) ghost.parts[i].el.setAttribute('fill', 'url(#vr-mark-lit)');
    dv.art.insertBefore(f.el, dv.art.firstChild);
    dv.bird.appendChild(ghost.el);
    var step = function (t) {
      var a = smooth(t / 0.66);
      for (var i = 0; i < ghost.parts.length; i++) ghost.parts[i].el.setAttribute('transform', about(215 * a * a - 120 * a * ghost.parts[i].w, 1 - 0.76 * a) + ' ' + ghost.pose + (ghost.parts[i].g === 'wing' ? ghost.wing : ''));
      ghost.el.setAttribute('opacity', (1 - smooth((t - 0.5) / 0.42)).toFixed(3));
      f.set(Math.pow(Math.sin(Math.PI * Math.min(1, t * 1.25)), 1.1), 3.6, 8);
    };
    step(0);
    ghost.el.setAttribute('filter', 'url(#' + f.id + ')');
    act(at, ABSORB, step, function () {
      if (f.el.parentNode) f.el.parentNode.removeChild(f.el);
      if (ghost.el.parentNode) ghost.el.parentNode.removeChild(ghost.el);
    });
  }

  /* ---- light: a glint over one dove after a landing, a band over the whole mark at the end. The light is
     a gradient that travels across copies of the drawing laid over it; x runs in the mark's resting pixels ---- */
  function light(list, at, dur, strength, share) {
    var items = null, width = 0, band = 0;
    var start = function () {
      items = [];
      var d = list[0].el.offsetWidth || 1;
      var first = list[0].el.offsetLeft, lastEl = list[list.length - 1].el;
      width = lastEl.offsetLeft + lastEl.offsetWidth - first;
      band = Math.max(18, width * share);
      for (var i = 0; i < list.length; i++) {
        var dv = list[i];
        var id = 'vr-mark-light-' + (++serial);
        var layer = svg('svg', { viewBox: '0 0 ' + W + ' ' + H, 'class': 'vr-mark__gleam', focusable: 'false' });
        var grad = svg('linearGradient', { id: id, gradientUnits: 'userSpaceOnUse', x1: '-40', y1: '0', x2: '-20', y2: '0' });
        grad.appendChild(svg('stop', { offset: '0', 'stop-color': '#fffaf0', 'stop-opacity': '0' }));
        grad.appendChild(svg('stop', { offset: '0.5', 'stop-color': '#fffaf0', 'stop-opacity': String(strength) }));
        grad.appendChild(svg('stop', { offset: '1', 'stop-color': '#fffaf0', 'stop-opacity': '0' }));
        layer.appendChild(grad);
        for (var j = 0; j < ART.pieces.length; j++) layer.appendChild(svg('path', { d: ART.pieces[j].d, fill: 'url(#' + id + ')', 'fill-rule': 'evenodd' }));
        dv.el.appendChild(layer);
        items.push({ dv: dv, layer: layer, grad: grad, left: dv.el.offsetLeft - first, k: d / W });
      }
    };
    act(at, dur, function (t) {
      if (!items) start();
      var x = lerp(-band, width + band, smooth(t));
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        var mid = (x - it.left) / it.k, half = band / it.k / 2, tilt = half * 0.36;
        if (it.dv.face < 0) { mid = W - mid; tilt = -tilt; }
        it.grad.setAttribute('x1', (mid - half).toFixed(2)); it.grad.setAttribute('y1', (H / 2 - tilt).toFixed(2));
        it.grad.setAttribute('x2', (mid + half).toFixed(2)); it.grad.setAttribute('y2', (H / 2 + tilt).toFixed(2));
      }
    }, function () {
      if (!items) return;
      for (var i = 0; i < items.length; i++) if (items[i].layer.parentNode) items[i].layer.parentNode.removeChild(items[i].layer);
    });
  }

  /* ---- the show ---- */
  var view = null;                    /* the window, the hall and the stage, measured when the show begins */
  var birds = [], dust = [];
  var sky = null, g = null, dpr = 1;
  var clock = 0, lastFrame = 0, textIn = false;

  function measure() {
    /* the width of the page without its scroll bar: the mark is made on the centre line of the text */
    var vw = document.documentElement.clientWidth || window.innerWidth, vh = window.innerHeight;
    STAGE = stageFor(vw);
    var head = document.querySelector('.shopify-section-header-sticky') || document.querySelector('.section-header') || document.querySelector('sticky-header');
    var hb = head ? head.getBoundingClientRect() : null;
    var roof = hb && hb.bottom > 0 && hb.bottom < vh * 0.34 ? hb.bottom : 0;
    var unit = Math.max(0.5, Math.min(1.25, Math.pow(vw / 1920, 0.42)));
    var d = doves[0].el.offsetWidth;
    var pad = Math.max(12, Math.round(24 * unit));
    var hall = { x0: pad, x1: vw - pad, y0: roof + Math.round(pad * 0.7), y1: vh - pad };
    var cx = Math.round(vw / 2), cy = Math.round(roof + (vh - roof) / 2);
    var bird = STAGE * FIRST * d;     /* a dove in flight is as large as the mark's dove will be when the first lands */
    return {
      iw: window.innerWidth, ih: window.innerHeight,
      vw: vw, vh: vh, roof: roof, unit: unit, d: d, pad: pad, hall: hall, cx: cx, cy: cy, bird: bird,
      diag: Math.sqrt(Math.pow(hall.x1 - hall.x0, 2) + Math.pow(hall.y1 - hall.y0, 2)),
      zone: { x: cx, y: cy, rx: 1.09 * d * STAGE + bird * 0.45, ry: H / W / 2 * d * STAGE + bird * 0.5 },
      keep: bird * 0.62
    };
  }
  function roomy(v) { return v.d > 20 && v.hall.x1 - v.hall.x0 > 250 && v.hall.y1 - v.hall.y0 > 300; }

  /*plan*/
  /* who lands when and where, and the path each one takes to be there on its beat. A dove keeps its own
     pace; the moment it comes in over the edge follows from the length of its path. */
  function plan(v) {
    var list = [], edges = [], i;
    /* four come in over each edge. The first three land from the side they came in on (their flight is
       short); the rest are dealt by chance */
    for (i = 3; i < COUNT; i++) edges.push(i === 3 ? 1 : i % 2);
    for (i = edges.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var tmp = edges[i]; edges[i] = edges[j]; edges[j] = tmp; }
    edges = [0, 1, 0].concat(edges);
    var wide = v.hall.x1 - v.hall.x0, high = v.hall.y1 - v.hall.y0, small = Math.min(wide, high);
    for (var n = 1; n <= COUNT; n++) {
      var side = (n - 1) % 2;                           /* left, right, left, right */
      var A = stagePlace(v, side, stageScale(down(n)));
      var speed = CRUISE * v.unit * rnd(0.94, 1.06);
      /* how tightly it may turn: about 150 degrees a second where the hall allows, tighter where the way
         past the middle is narrow; and where even that will not do, the middle is not kept clear */
      var R = Math.min(speed / 2.6, small * 0.2);
      var above = (high - 2 * (v.zone.ry + v.keep)) / 2 - v.keep, beside = (wide - 2 * (v.zone.rx + v.keep)) / 2 - v.keep;
      var way = Math.max(above, beside) * 0.5;
      var zone = v.zone;
      if (way < R) { if (way >= speed / 4.4) R = way; else zone = null; }
      var wanted = down(n) - (ENTER + rnd(0, ENTER_SPREAD));
      var path = route({ A: { x: A.x, y: A.y }, from: side ? 1 : -1, L: speed * (wanted - (1 - SLOW_TO) / 2 * BRAKE), edge: edges[n - 1], out: v.bird * 1.2, hall: v.hall, zone: zone, keep: v.keep, R: R, diag: v.diag, vw: v.vw, vh: v.vh });
      var time = path.len / speed + (1 - SLOW_TO) / 2 * BRAKE;
      list.push({ order: n, dove: doves[side], side: side, home: A, path: path, enter: down(n) - time, time: time, from: 1 - BRAKE / time, k: v.bird * rnd(0.84, 1.1) / W, speed: speed, R: R, zoneOn: !!zone,
        beat: rnd(0, 6.28), rate: rnd(3.3, 4.0), glideAt: rnd(0.8, 1.6), glideFor: 0, glide: 0, turn: 0, lean: null, done: false, last: null });
    }
    return list;
  }
  /*end plan*/

  function setStage(t) {
    var e = Math.max(0, Math.min(1, (t - RISE_AT) / RISE));
    e = e * e * e * (e * (e * 6 - 15) + 10);            /* gentle at both ends */
    var sb = slot.getBoundingClientRect();
    var tx = (view.cx - (sb.left + sb.width / 2)) * (1 - e), ty = (view.cy - (sb.top + sb.height / 2)) * (1 - e);
    logo.style.transform = 'translate(' + tx.toFixed(2) + 'px, ' + ty.toFixed(2) + 'px) scale(' + lerp(stageScale(t), 1, e).toFixed(4) + ')';
  }
  /* where the middle of a dove's body rests at this moment, in window coordinates, and how large the drawing is */
  function rest(dv) {
    var b = dv.el.getBoundingClientRect();
    var k = b.width / W;
    return { x: dv.face > 0 ? b.left + CENTRE[0] * k : b.right - CENTRE[0] * k, y: b.top + CENTRE[1] * k, k: k };
  }

  /* a little gold dust around the dove that has just come down */
  function burst(st, n) {
    var many = Math.round((view.vw < 750 ? 10 : 15) * (n === COUNT ? 1.4 : 1));
    var size = st.k * W;
    for (var i = 0; i < many; i++) {
      var a = rnd(0, 6.283), r0 = rnd(0.22, 0.56) * size, sp = rnd(22, 78) * view.unit * (0.7 + size / 160);
      dust.push({ x: st.x + Math.cos(a) * r0 * 1.15, y: st.y + Math.sin(a) * r0 * 0.85, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 12 * view.unit,
        life: rnd(0.8, 1.55), age: -rnd(0, 0.16), r: rnd(0.55, 1.55) * (view.vw < 750 ? 0.95 : 1.15), tw: rnd(0, 6.28), star: Math.random() < 0.2, c: DUST[Math.floor(Math.random() * DUST.length)] });
    }
  }
  function drawDust(dt) {
    if (!dust.length) return;
    g.save();
    g.globalCompositeOperation = 'lighter';
    var drag = Math.exp(-2.3 * dt);
    for (var i = dust.length - 1; i >= 0; i--) {
      var p = dust[i];
      p.age += dt;
      if (p.age < 0) continue;
      if (p.age >= p.life) { dust.splice(i, 1); continue; }
      p.vx *= drag; p.vy *= drag;
      p.x += p.vx * dt; p.y += p.vy * dt;
      var a = Math.pow(Math.sin(Math.PI * p.age / p.life), 0.7) * (0.7 + 0.3 * Math.sin(p.tw + p.age * 9));
      g.globalAlpha = Math.max(0, Math.min(1, a));
      g.fillStyle = p.c;
      g.beginPath(); g.arc(p.x, p.y, p.r, 0, 6.283); g.fill();
      if (p.star) {
        var l = p.r * 3.4 * (0.6 + 0.4 * Math.sin(p.tw * 2 + p.age * 12));
        g.strokeStyle = p.c; g.lineWidth = 0.6;
        g.beginPath(); g.moveTo(p.x - l, p.y); g.lineTo(p.x + l, p.y); g.moveTo(p.x, p.y - l); g.lineTo(p.x, p.y + l); g.stroke();
      }
    }
    g.restore();
  }

  function land(b) {
    var dv = b.dove, at = clock;
    burst(b.last, b.order);
    if (!dv.formed) { morph(dv, b.last, at); if (b.order < COUNT) light([dv], at + MELT * 0.8, GLINT, 0.6, 0.42); }
    else { absorb(dv, b.last, at); if (b.order < COUNT) light([dv], at + ABSORB * 0.55, GLINT, 0.6, 0.42); }
  }

  var shapes = null, gold = null, far = null;
  function draw(b, dt) {
    var u = (clock - b.enter) / b.time;
    if (u < 0 || b.done) return;
    if (u >= 1 && b.last) { b.done = true; land(b); return; }
    u = Math.min(u, 0.999);
    var now = rest(b.dove);
    var s = covered(u, b.from) * b.path.len;
    var p = along(b.path, s), q = along(b.path, Math.min(b.path.len, s + 6));
    var left = (1 - u) * b.time;                         /* seconds to the touch */
    var settle = smooth(1 - left / 1.05);                /* 0 in flight, 1 as it comes down */
    var drift = smooth(1 - left / 1.6);                  /* its place may have moved a little (the mark grows) */
    var x = p.x + (now.x - b.home.x) * drift, y = p.y + (now.y - b.home.y) * drift;
    var dx = q.x - p.x, dy = q.y - p.y, sp = Math.sqrt(dx * dx + dy * dy) || 1;
    /* which way it faces: the way it travels, turning round over a moment rather than flipping */
    var want = Math.abs(dx) > 0.3 * sp ? (dx > 0 ? 1 : -1) : (b.turn >= 0 ? 1 : -1);
    if (left < 0.5) want = b.side ? -1 : 1;              /* and at the last it faces as the mark's dove does */
    if (b.turn === 0) b.turn = want;
    b.turn += (want - b.turn) * Math.min(1, dt * 9);
    var faceNow = Math.abs(b.turn) < 0.12 ? (b.turn < 0 ? -0.12 : 0.12) : b.turn;
    /* the body lies along the path, a little nose up, and rears half way up as it brakes */
    var climb = Math.atan2(dy, Math.abs(dx) + 0.0001);
    climb = Math.max(-0.75, Math.min(0.75, climb));
    var lean = (AXIS - 0.12 + climb * (1 - 0.6 * settle)) * (1 - 0.55 * settle);
    b.lean = b.lean === null ? lean : b.lean + (lean - b.lean) * Math.min(1, dt * 10);
    /* the wing: up is the mark's own pose (1); the stroke carries it through edge on (0) to below (-0.8) */
    b.glideAt -= dt;
    if (b.glideAt <= 0 && b.glideFor <= 0 && settle < 0.2) { b.glideFor = rnd(0.2, 0.36); b.glideAt = rnd(0.9, 1.8); }
    if (b.glideFor > 0) b.glideFor -= dt;
    b.glide += ((b.glideFor > 0 ? 1 : 0) - b.glide) * Math.min(1, dt * 12);
    b.beat += dt * 6.283 * b.rate * (1 + 0.55 * settle) * (1 - 0.85 * b.glide);
    var depth = 0.8 * (1 - 0.45 * settle);
    var stroke = function (r) { return r >= 0 ? Math.pow(r, 0.8) : -depth * Math.pow(-r, 0.8); };
    var end = smooth(1 - left / 0.4);                    /* the last moment before it touches */
    var near = lerp(stroke(Math.cos(b.beat)), 0.46, b.glide);
    var farW = lerp(stroke(Math.cos(b.beat - 0.8)), 0.4, b.glide);
    var k = lerp(b.k, now.k, smooth(1 - left / 1.5));    /* it grows to the size of the dove it is making for */
    var bob = k * 2.1 * Math.sin(b.beat - 0.5) * (1 - settle) * (1 - b.glide);
    var st = { x: x, y: y + bob, k: k, face: faceNow, lean: b.lean, near: near, far: farW, farAlpha: 1 - end, alpha: smooth((clock - b.enter) / 0.25) };
    paint(g, shapes, gold, far, st);
    b.last = st;
  }

  function sizeSky() {
    sky.width = Math.round(view.vw * dpr); sky.height = Math.round(view.vh * dpr);
    sky.style.width = view.vw + 'px'; sky.style.height = view.vh + 'px';
  }
  function frame(now) {
    if (state !== 'flying') return;
    var dt = lastFrame ? Math.min(0.05, (now - lastFrame) / 1000) : 0.016;
    lastFrame = now;
    clock += dt;
    setStage(clock);
    runActs(clock, false);
    if (!textIn && clock >= TEXT_AT) { textIn = true; hero.classList.remove('is-awaiting-mark'); tell(); }
    if (sky) {
      g.setTransform(dpr, 0, 0, dpr, 0, 0);
      g.clearRect(0, 0, view.vw, view.vh);
      var flying = 0;
      for (var i = 0; i < birds.length; i++) { draw(birds[i], dt); if (!birds[i].done) flying++; }
      drawDust(dt);
      if (!flying && !dust.length && clock > down(COUNT) + 0.2) { sky.parentNode.removeChild(sky); sky = null; }
    }
    if (clock < END_AT) { window.requestAnimationFrame(frame); return; }
    finish(false);
  }

  function begin() {
    if (state !== 'waiting') return;
    view = measure();
    if (!roomy(view)) { finish(true); return; }
    state = 'flying';
    dpr = Math.min(window.devicePixelRatio || 1, 2, Math.max(1, Math.sqrt(5200000 / (view.vw * view.vh))));
    sky = document.createElement('canvas');
    sky.className = 'vr-brand-sky';
    sky.setAttribute('aria-hidden', 'true');
    document.body.appendChild(sky);
    g = sky.getContext('2d');
    sizeSky();
    var group = function (name) { var d = ''; for (var i = 0; i < ART.pieces.length; i++) if (ART.pieces[i].g === name) d += ART.pieces[i].d; return new Path2D(d); };
    shapes = { wing: group('wing'), body: group('body'), beak: group('beak'), tail: group('tail') };
    gold = g.createLinearGradient(0, 38, W, 66);
    for (var i = 0; i < GOLD.length; i++) gold.addColorStop(GOLD[i][0], GOLD[i][1]);
    far = g.createLinearGradient(0, 38, W, 66);
    for (i = 0; i < GOLD_FAR.length; i++) far.addColorStop(GOLD_FAR[i][0], GOLD_FAR[i][1]);
    birds = plan(view);
    birds.sort(function (a, b) { return a.k - b.k; });   /* the smaller ones are drawn first, as if further off */
    light(doves, SHINE_AT, GLEAM, 0.95, 0.5);
    clock = 0; lastFrame = 0;
    setStage(0);
    window.requestAnimationFrame(frame);
  }

  /* the end, in its own time (fast = false) or at once (a scroll, a tap, a key, a turned phone, or a show that
     could not run): everything the show added is taken away and the mark is in its place */
  function finish(fast) {
    if (state === 'done' || state === 'still') return;
    state = 'done';
    for (var i = 0; i < timers.length; i++) window.clearTimeout(timers[i]);
    unlisten();
    runActs(0, true);
    for (i = 0; i < doves.length; i++) if (!doves[i].el.classList.contains('is-perched')) { doves[i].el.classList.remove('is-forming'); perch(doves[i], fast); }
    tell();
    if (fast && logo.style.transform) {
      logo.style.transition = 'transform 0.7s cubic-bezier(0.22, 0.61, 0.36, 1)';
      void logo.offsetWidth;
      logo.style.transform = 'none';
      window.setTimeout(function () { logo.style.transition = ''; logo.style.transform = ''; }, 800);
    } else {
      logo.style.transform = '';
    }
    hero.classList.remove('is-awaiting-mark');
    if (sky) {
      var s = sky; sky = null;
      s.style.transition = 'opacity 0.35s'; s.style.opacity = '0';
      window.setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 420);
    }
  }

  /* anything the visitor does ends the show */
  var y0 = 0;
  function onMove() { finish(true); }
  function onScroll() { if (Math.abs((window.pageYOffset || 0) - y0) > 24) finish(true); }
  function onKey(e) { var k = e.key; if (k === ' ' || k === 'Enter' || k === 'Escape' || k === 'PageDown' || k === 'ArrowDown' || k === 'End' || k === 'Tab') finish(true); }
  function onResize() { if (view && (Math.abs(window.innerWidth - view.iw) > 2 || Math.abs(window.innerHeight - view.ih) > 140)) finish(true); }
  function listen() {
    y0 = window.pageYOffset || 0;
    window.addEventListener('wheel', onMove, { passive: true });
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('pointerdown', onMove, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('keydown', onKey);
    window.addEventListener('resize', onResize);
  }
  function unlisten() {
    window.removeEventListener('wheel', onMove);
    window.removeEventListener('touchmove', onMove);
    window.removeEventListener('pointerdown', onMove);
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('keydown', onKey);
    window.removeEventListener('resize', onResize);
  }

  /* delay: milliseconds until the doors begin to open. Returns true if the show will run (the hero text then
     waits for the mark), false if the mark is simply shown. */
  function play(delay) {
    if (state) return state === 'waiting' || state === 'flying';
    if (reduce || !window.requestAnimationFrame || !window.Path2D || !roomy(measure())) { still(); return false; }
    state = 'waiting';
    hero.classList.add('is-awaiting-mark');
    listen();
    timers.push(window.setTimeout(begin, Math.max(0, delay || 0)));
    /* whatever happens (a tab left in the background, a browser that stops drawing), the text is never held for long */
    timers.push(window.setTimeout(function () { finish(true); }, Math.max(0, delay || 0) + (END_AT + 6) * 1000));
    return true;
  }

  build();
  window.VRBrandBirds = { play: play, still: still, skip: function () { finish(true); } };
})();

/*
  Gold leaf over the Our Story page (round 20). The same flakes as on the rate pages: small irregular pieces
  of leaf that fall slowly, sway and turn, and come to rest in an uneven drift at the foot of the page, just above the strip of magazines (round 23 and round 25:
  no glint, leaf does not sparkle). Here they fall over the
  whole page, in front of the cards and the pictures, on one canvas pinned to the window. They begin when
  the house mark is in its place (after the doves, or at once when there is no intro), and never run for
  visitors who ask for reduced motion or a light connection.
*/
(function () {
  'use strict';
  var host = document.querySelector('[data-vr-brand-leaf]');
  if (!host || host.getAttribute('data-vr-brand-leaf') === 'off' || host.getAttribute('data-leaf-ready')) return;
  host.setAttribute('data-leaf-ready', '1');
  if (!window.requestAnimationFrame) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var conn = navigator.connection || {};
  if (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) return;

  /* lit face, body, deep edge */
  var TONES = [
    [[255, 246, 205], [240, 203, 105], [138, 94, 10]],
    [[255, 238, 178], [226, 182, 74], [122, 82, 12]],
    [[255, 250, 228], [244, 214, 128], [160, 112, 22]]
  ];
  var sky = null, ctx = null, w = 0, h = 0, dpr = 1;
  var pieces = [], running = false, started = false, last = 0, clock = 0, raf = 0;
  var pile = [], pileMax = 0, rested = [], restMax = 0, ground = null, gctx = null, gh = 0, gTop = 0, gBottom = 0;
  var PILE_COL = 6, SETTLE = 80; /* the ground is measured in columns this wide; a piece slows over this many pixels */

  function rand(a, b) { return a + Math.random() * (b - a); }
  function shape() {
    /* an irregular pentagon or hexagon: angles spread round the circle, radii jittered */
    var n = 5 + Math.floor(Math.random() * 2), points = [], a = rand(0, Math.PI * 2);
    for (var i = 0; i < n; i++) {
      a += (Math.PI * 2 / n) * rand(0.6, 1.4);
      var r = rand(0.55, 1);
      points.push([Math.cos(a) * r, Math.sin(a) * r * rand(0.7, 1)]);
    }
    return points;
  }
  function piece(fresh) {
    var depth = Math.random(); /* 0 far: small, slow, faint. 1 near: larger, quicker, bright */
    return {
      x: rand(0, w), y: fresh ? rand(-60, -8) : rand(0, h),
      size: 2.4 + depth * 5, speed: 13 + depth * 25, sway: rand(6, 22), swayK: 1, swaySpeed: rand(0.3, 0.8), phase: rand(0, Math.PI * 2),
      rot: rand(0, Math.PI * 2), rotSpeed: rand(-0.9, 0.9), flip: rand(0, Math.PI * 2), flipSpeed: rand(0.6, 1.7),
      alpha: 0.45 + depth * 0.45, depth: depth, tones: TONES[Math.floor(Math.random() * TONES.length)], points: shape()
    };
  }
  function measure() {
    var oldH = h, oldCols = pile.length;
    w = window.innerWidth; h = window.innerHeight;
    dpr = Math.min(2, window.devicePixelRatio || 1, Math.max(1, Math.sqrt(5200000 / (w * h))));
    sky.width = Math.max(1, Math.round(w * dpr)); sky.height = Math.max(1, Math.round(h * dpr));
    sky.style.width = w + 'px'; sky.style.height = h + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var count = Math.max(14, Math.min(60, Math.round(w * h / 36000)));
    while (pieces.length < count) pieces.push(piece(false));
    pieces.length = count;
    /* the ground and the drift (round 23): kept through a change of height alone (a phone hiding its bar), begun
       afresh at a new width */
    /* round 25: the drift lies on a canvas of its own at the foot of the page (just above the strip of magazines),
       not at the foot of the window, and keeps its place as the page scrolls. The pieces at rest are kept from the
       canvas's bottom edge up, so a change of height leaves them where they lie; a new width begins afresh. */
    pileMax = Math.round(h * 0.045);
    restMax = Math.max(40, Math.round(w / 8));
    gh = pileMax + 16;
    ground.width = Math.max(1, Math.round(w * dpr)); ground.height = Math.max(1, Math.round(gh * dpr));
    ground.style.width = w + 'px'; ground.style.height = gh + 'px';
    gctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var cols = Math.ceil(w / PILE_COL), k;
    if (cols !== oldCols) { pile = []; for (k = 0; k < cols; k++) pile.push(0); rested = []; }
    for (k = 0; k < rested.length; k++) lay(rested[k]);
  }
  function mix(a, b, t) {
    return 'rgb(' + Math.round(a[0] + (b[0] - a[0]) * t) + ',' + Math.round(a[1] + (b[1] - a[1]) * t) + ',' + Math.round(a[2] + (b[2] - a[2]) * t) + ')';
  }
  /* Round 23: no glint. Leaf does not sparkle; a piece is only a little paler as its face turns to the light. */
  function facet(c, p, x, y, lit) {
    c.save();
    c.translate(x, y);
    c.rotate(p.rot);
    c.scale(p.size, p.size * Math.max(0.1, lit));
    c.beginPath();
    for (var i = 0; i < p.points.length; i++) { if (i === 0) c.moveTo(p.points[i][0], p.points[i][1]); else c.lineTo(p.points[i][0], p.points[i][1]); }
    c.closePath();
    c.globalAlpha = p.alpha;
    c.fillStyle = lit > 0.5 ? mix(p.tones[1], p.tones[0], (lit - 0.5) * 1.3) : mix(p.tones[2], p.tones[1], lit * 2);
    c.fill();
    c.restore();
  }
  function draw(p, x, y) { facet(ctx, p, x, y, Math.abs(Math.cos(p.flip))); }

  /* Round 23: the leaf comes to rest. The bottom of the window is the ground; a piece that nears it slows over
     its last stretch, its sway dying, and lies where it fell. The ground rises unevenly where pieces have
     fallen, up to a shallow drift. The pieces at rest are kept on a canvas of their own, drawn once each. */
  function groundAt(x) { var c = Math.max(0, Math.min(pile.length - 1, Math.floor(x / PILE_COL))); return gBottom - (pile[c] || 0); }
  function lay(r) { facet(gctx, r, r.x, gh + r.y, r.lit); }
  function settle(p, x) {
    var c = Math.max(0, Math.min(pile.length - 1, Math.floor(x / PILE_COL))), add = p.size * 0.3;
    pile[c] = Math.min(pileMax, (pile[c] || 0) + add);
    if (c > 0) pile[c - 1] = Math.min(pileMax, (pile[c - 1] || 0) + add * 0.45);
    if (c + 1 < pile.length) pile[c + 1] = Math.min(pileMax, (pile[c + 1] || 0) + add * 0.45);
    var r = { x: x, y: p.y - gBottom, rot: p.rot, lit: rand(0.3, 0.85), size: p.size, alpha: p.alpha, tones: p.tones, points: p.points };
    rested.push(r);
    if (rested.length > restMax) {
      /* the drift is full: the oldest quarter goes and the rest is drawn again */
      rested.splice(0, Math.ceil(restMax * 0.25));
      gctx.clearRect(0, 0, w, gh);
      for (var i = 0; i < rested.length; i++) lay(rested[i]);
    } else lay(r);
  }

  function frame(now) {
    raf = 0;
    if (!running) return;
    var dt = Math.min(0.05, (now - last) / 1000 || 0);
    last = now;
    clock += dt;
    ctx.clearRect(0, 0, w, h);
    /* where the foot of the page stands in the window this frame: the drift can only be reached while it is in view */
    var gr = ground.getBoundingClientRect(); gTop = gr.top; gBottom = gr.bottom;
    var reachable = gBottom > 0 && gTop < h + SETTLE;
    for (var i = 0; i < pieces.length; i++) {
      var p = pieces[i];
      var x = p.x + Math.sin(p.phase + clock * p.swaySpeed) * p.sway * p.swayK;
      var left = reachable ? groundAt(x) - p.size * 0.45 - p.y : Infinity;
      /* below the drift already (the visitor has scrolled on and the foot of the page stands part-way up the window):
         nothing to lie on, so the piece falls on and leaves at the foot of the window like any other */
      if (left < -p.size * 2) left = Infinity;
      if (left < SETTLE) {
        /* the last stretch: slower as the ground nears, the sway dying, the turning too */
        p.y += p.speed * Math.max(0.1, left / SETTLE) * dt;
        p.swayK = Math.max(0, p.swayK - dt * 1.2);
        p.flipSpeed *= 1 - 1.4 * dt;
        p.rotSpeed *= 1 - 1.4 * dt;
        if (left <= 0.5) { settle(p, x); pieces[i] = piece(true); continue; }
      } else {
        p.y += p.speed * dt;
        if (p.y > h + p.size * 2) {
          /* out at the foot of the window. While the foot of the page is further down, the piece lands on the drift
             unseen, so the drift grows with the visit and is there when the visitor reaches it; once the page's foot
             has gone by above, there is nothing below to lie on and the piece is simply gone. */
          if (gBottom > h) { p.y = groundAt(x) - p.size * 0.45; settle(p, x); }
          pieces[i] = piece(true); continue;
        }
      }
      p.rot += p.rotSpeed * dt;
      p.flip += p.flipSpeed * dt;
      draw(p, x, p.y);
    }
    raf = window.requestAnimationFrame(frame);
  }
  function run() { if (running || !started || document.hidden) return; running = true; last = performance.now(); raf = window.requestAnimationFrame(frame); }
  function rest() { running = false; if (raf) window.cancelAnimationFrame(raf); raf = 0; }
  function start() {
    if (started) return;
    started = true;
    sky = document.createElement('canvas');
    sky.className = 'vr-brand-leaf';
    sky.setAttribute('aria-hidden', 'true');
    ctx = sky.getContext('2d');
    if (!ctx) return;
    ground = document.createElement('canvas');
    ground.className = 'vr-brand-leaf-ground';
    ground.setAttribute('aria-hidden', 'true');
    gctx = ground.getContext('2d');
    if (!gctx) return;
    host.appendChild(ground);
    document.body.appendChild(sky);
    measure();
    var timer = 0;
    window.addEventListener('resize', function () { window.clearTimeout(timer); timer = window.setTimeout(measure, 160); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) rest(); else run(); });
    run();
    /* the leaf comes up out of nothing rather than appearing all at once */
    window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { sky.classList.add('is-falling'); ground.classList.add('is-falling'); }); });
  }
  document.addEventListener('vr:brand-mark-ready', start);
  /* should the mark never report (its script failed, or the page has no mark), the leaf still falls */
  window.addEventListener('load', function () { window.setTimeout(start, 26000); });
})();
